import * as React from 'react';
import './DashboardMenu.scss';
import { isSuperUser, isPowerUser } from 'src/utils/permissions';
import partSmartIcon from 'src/assets/partSmart';
import partSmartCircle from 'src/assets/partSmartCircle';
import { goToPartSmartFromDashboard, ifLoggedIn, partSmartUrl } from 'src/utils/navigation';
import { goToHome, goToLogin } from 'src/utils/navigation';

interface IDashboardMenuProps {
  selected: 'switch' | 'manage' | 'password' | 'e-check' | 'unlock' | 'partsmartlogin';
  onSelect(selected: string): void;
}

export function DashboardMenu(props: IDashboardMenuProps) {
  function getActiveClass(
    item: 'switch' | 'manage' | 'password' | 'e-check' | 'credits' | 'unlock' | 'partsmartlogin'
  ): string {
    return props.selected === item ? 'active' : '';
  }

  const removeEcheckSearchStorage=()=>{
    // Reset 'List of Echeckpayments' searching
     localStorage.removeItem('searchFielda');
     localStorage.removeItem('searchPaymentDate');
    
  }

  const goToPartSmartView=()=>{
    goToLogin();
    // goToPartSmartFromDashboard();
    
  }


  return (
    <div className="rp-dashboardmenu">
      <button
        className={`rp-dashboardmenu--item ${getActiveClass('switch')}`}
        onClick={() => props.onSelect('switch')}
      >
        <i className="rpds rpds-user" />
        <span>Switch to Client's Account</span>
      </button>
      {isSuperUser() && (
        <button
          className={`rp-dashboardmenu--item ${getActiveClass('manage')}`}
          onClick={() => props.onSelect('manage')}
        >
          <i className="rpds rpds-turn-sign" />
          <span>Manage Power Users</span>
        </button>
      )}
      <button
        className={`rp-dashboardmenu--item ${getActiveClass('password')}`}
        onClick={() => props.onSelect('password')}
      >
        <i className="rpds rpds-lock" />
        <span>Change your Password</span>
      </button>
      {isSuperUser() && (
        <button
          className={`rp-dashboardmenu--item ${getActiveClass('e-check')}`}
          onClick={() => {props.onSelect('e-check');removeEcheckSearchStorage()}}
        >
          <i className="rpds rpds-ticket" />
          <span>Manage E-Check Payments</span>
        </button>
      )}
      {isSuperUser() && (
        <button
          className={`rp-dashboardmenu--item ${getActiveClass('credits')}`}
          onClick={() => props.onSelect('credits')}
        >
          <i className="rpds rpds-ticket" />
          <span>Manage Apply Credits</span>
        </button>
      )}
      {isSuperUser() && (
        <button
          className={`rp-dashboardmenu--item ${getActiveClass('unlock')}`}
          onClick={() => props.onSelect('unlock')}
        >
          <i className="rpds rpds-ticket" />
          <span>Unlock Login User</span>
        </button>
      )}

        {isSuperUser() && (
        <button
          className={`rp-dashboardmenu--item`}
          onClick={() => props.onSelect('partsmartlogin')}
        >
           <img
              src={partSmartCircle}
              alt="Part Smart"
              className='part-smart-img' 
            />
          <span>Part Smart</span>
        </button>
      )}

        {isPowerUser() && (
        <button
          className={`rp-dashboardmenu--item`}
          onClick={() => props.onSelect('partsmartlogin')}
        >
           <img
              src={partSmartCircle}
              alt="Part Smart"
              className='part-smart-img' 
            />
          <span>Part Smart</span>
        </button>
      )}
    </div>
  );
}
